import React from 'react';
import { Box, Typography, Container, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NewspaperIcon from '@mui/icons-material/Newspaper';

function SajtoRadar() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center', backgroundColor: '#f9f9f9', borderRadius: 2 }}>
        <NewspaperIcon color="primary" sx={{ fontSize: 80, mb: 2, opacity: 0.8 }} />
        <Typography variant="h3" component="h1" gutterBottom color="primary">
          SajtóRadar
        </Typography>
        <Typography variant="h5" color="text.secondary" paragraph>
          A székelyföldi földtani hírek és sajtómegjelenések gyűjtőhelye.
        </Typography>
        <Box sx={{ my: 4, p: 3, border: '2px dashed #ccc', borderRadius: 2 }}>
          <Typography variant="h6" color="text.secondary">
            Ez a szekció jelenleg fejlesztés alatt áll.
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Hamarosan itt találhatja meg a Társulattal és a földtani kutatásokkal kapcsolatos legfrissebb híreket.
          </Typography>
        </Box>
        <Button 
          variant="contained" 
          size="large" 
          onClick={() => navigate(`/${i18n.language}/`)}
          sx={{ mt: 2 }}
        >
          Vissza a főoldalra
        </Button>
      </Paper>
    </Container>
  );
}

export default SajtoRadar;
